import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import linkUtils from 'src/utils/linkUtils';
import FollowButton from 'src/components/buttons/followButton';
import WriteButton from 'src/modules/community/shared/components/writeButton';
import Newbies from './communityHeaderNewbies';
import signupContext from 'src/constants/signupContext';
import { userIsMemberOfCurrentGroup } from 'src/utils/context';
import { numberFormat } from 'src/utils/string';

const CommunityHeaderContent = ({ community, currentUser, newbies, onFollow, isWriteCTAvisible, trackingSection }) => {
  const logoStyle = {
    backgroundImage: `url("${linkUtils.generateGroupImageUrl(community.logoImageHash)}")`,
  };
  const isMemberOfCommunity = userIsMemberOfCurrentGroup(currentUser, community);

  return (
    <div className="community-header__content">
      <div className="community-header__desc">
        <div className="community-header__logo">
          <div
            className="community-header__logo-img"
            style={logoStyle}
          />
        </div>
        <div className="community-header__desc-content" >
          <div className="community-header__title" >{community.name}</div>
          {(!!currentUser || community.followerCount >= 300) && (
            <div className="community-header__subtitle" >
              {numberFormat(community.followerCount)} {i18n.t('members')} • {numberFormat(community.postCount)} {i18n.t('posts')}
            </div>
          )}
          {newbies.length > 0 &&
          <div>
            <Newbies
              className="visible-sm"
              community={community}
              currentUser={currentUser}
              newbies={newbies.slice(0, 8)}
            />
            <Newbies
              className="hidden-sm"
              community={community}
              currentUser={currentUser}
              newbies={newbies.slice(0, 13)}
            />
          </div>}
        </div>
        <div className="community-header__desc-actions">
          <FollowButton
            community={community}
            followType="group"
            isActive={!!currentUser}
            isFollowing={isMemberOfCommunity}
            signupContext={{
              element: signupContext.element.FOLLOW,
              section: trackingSection || signupContext.section.BANNER,
            }}
            user={currentUser}
          />
          {isWriteCTAvisible && (
            <WriteButton
              community={community}
              currentUser={currentUser}
              trackingSection={trackingSection}
              onFollow={onFollow}
            >
              {i18n.t('Write')}
            </WriteButton>
          )}
        </div>
      </div>
    </div>
  );
};

CommunityHeaderContent.propTypes = {
  community: PropTypes.object,
  currentUser: PropTypes.object,
  isWriteCTAvisible: PropTypes.bool,
  newbies: PropTypes.array,
  onFollow: PropTypes.func,
};

CommunityHeaderContent.defaultProps = {
  community: {},
  currentUser: {},
  isWriteCTAvisible: true,
  newbies: [],
  onFollow: () => {},
};

export default CommunityHeaderContent;



// WEBPACK FOOTER //
// ./src/modules/community/shared/components/header/communityHeaderContent.js